const SILVER = 'var(--solved, #A7754D)';

interface DefaultAvatarProps {
  username: string;
  size?: number;
}

export default function DefaultAvatar({ username, size = 32 }: DefaultAvatarProps) {
  const color = SILVER;
  const letter = (username || '?')[0].toUpperCase();
  const fontSize = Math.round(size * 0.45);

  return (
    <svg width={size} height={size} style={{ flexShrink: 0, display: 'block' }}>
      <circle cx={size / 2} cy={size / 2} r={size / 2} fill={color} />
      <text
        x={size / 2}
        y={size / 2}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={fontSize}
        fontWeight={700}
        fill="white"
        style={{ pointerEvents: 'none', userSelect: 'none', fontFamily: 'var(--font-mono)' }}
      >
        {letter}
      </text>
    </svg>
  );
}
